import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  body: {
    maxWidth: '80%',
    borderRadius: 4,
  },
  themeDefault: {
    backgroundColor: '#f5f5f5',
  },
  themePrimary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,

    '& $time': {
      color: grey[300],
    },
  },
  sender: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  left: {
    justifyContent: 'flex-start',
  },
  right: {
    justifyContent: 'flex-end',
  },
  time: {
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
